import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import commonStyles from "../idw-table.less";
import { flexRender, Row } from "@tanstack/react-table";

type IdwTableRowProps<T> = {
    row: Row<T>;
    headers: Array<any>;
    renderExpandedComponent?: (row: any) => React.ReactNode;
    renderTableRowHoverComponent?: (props: any, row: any) => React.ReactNode;
    onClickTableRow: (row: any) => void;
};

export const IdwTableRow = <T extends object>(props: IdwTableRowProps<T>) => {
    const { row, headers, renderExpandedComponent, renderTableRowHoverComponent, onClickTableRow } = props;

    const handleTableRowClick = () => {
        if (onClickTableRow) {
            onClickTableRow(row);
        }
    };

    return (
        <>
            {renderTableRowHoverComponent ? (
                <OverlayTrigger overlay={(props: any) => renderTableRowHoverComponent(props, row)}>
                    <tr key={row.id} onClick={handleTableRowClick}>
                        {row.getVisibleCells().map((cell) => (
                            <td key={cell.id}>
                                {flexRender(
                                    cell.column.columnDef.cell,
                                    cell.getContext()
                                )}
                            </td>
                        ))}
                    </tr>
                </OverlayTrigger>
            ) : (
                <tr key={row.id} onClick={handleTableRowClick}>
                    {row.getVisibleCells().map((cell) => (
                        <td key={cell.id}>
                            {flexRender(
                                cell.column.columnDef.cell,
                                cell.getContext()
                            )}
                        </td>
                    ))}
                </tr>
            )}
            {renderExpandedComponent && row.getIsExpanded() ? (
                <tr className={commonStyles.expandedTableRow} onClick={handleTableRowClick}>
                    <td className={commonStyles.expandedTableRowTd} colSpan={headers.length}>
                        {renderExpandedComponent(row)}
                    </td>
                </tr>
            ) : null}
        </>
    );
};